/**
 * RENDA-K フェイスプレート上のセクション枠。
 * 見出しは濃紺のステッカーピル（少し傾ける）で、スプラ風の
 * トイガンパネルの区画を模す（ページ固有 UI）。
 */

import React, { ReactNode } from "react";
import styled from "styled-components";

import { RENDA_FONT, RENDA_PANEL } from "../palette";

const Section = styled.section`
  border: 2px solid ${RENDA_PANEL.sectionBorder};
  border-radius: 16px;
  padding: 20px 14px 14px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

const Title = styled.h3`
  position: absolute;
  top: -12px;
  left: 12px;
  margin: 0;
  padding: 3px 12px;
  font-family: ${RENDA_FONT};
  font-weight: 800;
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #fffbef;
  background: ${RENDA_PANEL.outline};
  border-radius: 999px;
  line-height: 1.4;
  transform: rotate(-2deg);
  box-shadow: 0 2px 4px rgba(37, 42, 64, 0.3);
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 10px 14px;
`;

export interface PanelSectionProps {
  title: string;
  children: ReactNode;
  /** true で子要素を縦積みにする（波形・エディタ等の面もの用） */
  stacked?: boolean;
}

const PanelSection: React.FC<PanelSectionProps> = ({
  title,
  children,
  stacked = false,
}) => (
  <Section>
    <Title>{title}</Title>
    {stacked ? children : <Row>{children}</Row>}
  </Section>
);

export default PanelSection;
